import script from "./AlojamientosLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./AlojamientosLanding.vue?vue&type=script&setup=true&lang=js"

import "./AlojamientosLanding.vue?vue&type=style&index=0&id=7b352c8b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b352c8b"]])

export default __exports__